<mat-form-field class="vzc-password__full-field" floatLabel="always" appearance="outline" color="accent">
  <mat-label i18n="@@S_ACCOUNT_ACTIVATION_INPUT_PASSWORD_LABEL" id="aa-password-label" for="aa-password">New password</mat-label>
  <input
    matInput
    [formControl]="password"
    id="aa-password"
    name="aa-password"
    type="password"
    required="required"
    i18n-placeholder="@@S_ACCOUNT_ACTIVATION_INPUT_PASSWORD_PLACEHOLDER"
    placeholder="Enter new password"
    aria-labelledby="aa-password-label"
    autocomplete="new-password"
  />

  <mat-hint *ngIf="password.invalid" i18n="@@S_ACCOUNT_ACTIVATION_INPUT_PASSWORD_HINT">
    Password must be at least 8 characters long.
  </mat-hint>
  <mat-error *ngIf="password.invalid" i18n="@@V_ACCOUNT_ACTIVATION_INPUT_PASSWORD_ERROR">
    Password must be at least 8 characters long.
  </mat-error>
</mat-form-field>

<mat-form-field class="vzc-password__full-field" floatLabel="always" appearance="outline" color="accent">
  <mat-label i18n="@@S_ACCOUNT_ACTIVATION_INPUT_CONFIRM_PASSWORD_LABEL" id="aa-password-confirm-label" for="aa-password-confirm">
    Confirm new password
  </mat-label>
  <input
    matInput
    [formControl]="passwordConfirm"
    id="aa-password-confirm"
    name="aa-password-confirm"
    type="password"
    required="required"
    i18n-placeholder="@@S_ACCOUNT_ACTIVATION_INPUT_CONFIRM_PASSWORD_PLACEHOLDER"
    placeholder="Re-enter new password"
    aria-labelledby="aa-password-confirm-label"
    autocomplete="new-password"
  />

  <mat-error *ngIf="passwordConfirm.hasError('mismatch')" i18n="@@V_ACCOUNT_ACTIVATION_INPUT_PASSWORD_CONFIRM_ERROR">
    Passwords do not match. Try again.
  </mat-error>
</mat-form-field>
